module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/97.9f8b24c7.png";